import { render, staticRenderFns } from "./TagsSelectorModal.vue?vue&type=template&id=2a8250a7"
import script from "./TagsSelectorModal.vue?vue&type=script&lang=js"
export * from "./TagsSelectorModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports